export const en = {
  app: {
    name: 'Dominoes',
  },
  seo: {
    title:
      'Dominoes Online — Kozyol, Telephone & All Fives, Free | BN-games',
    description:
      'Play Russian dominoes free in your browser — Kozyol (Goat), Telephone and All Fives (Muggins), 2–4 players. Against bots or friends online. No sign-up.',
    social:
      'Dominoes in your browser — Kozyol (Goat), Telephone and All Fives. Play friends online or bots.',
    h1:
      'Dominoes online — Kozyol, Telephone and All Fives',
    intro:
      'All three games here use a double-six set of 28 tiles. Kozyol ("the goat") is the Russian courtyard classic: nothing scores during play — when a hand ends, the losers write down the pips left in their hands, and whoever reaches 101 loses the match and is the goat. Telephone is the Russian take on All Fives: you score whenever the open ends add up to a multiple of five, the first hand opens with the [2|3], and the first move passes around the table every hand. All Fives, also called Muggins, is the classic scoring game: whenever the open ends of the layout add up to a multiple of five, you score that total.\n\nPlay free in your browser with two to four players — against bots, on one device, or online with friends by room code. Every online deal is provably fair.',
    rulesTitle:
      'Dominoes Rules — Kozyol, Telephone & All Fives (Muggins) | BN-games',
    rulesDescription:
      'How to play dominoes: Kozyol (Goat), Telephone and All Fives (Muggins) — setup, play, scoring and how a hand and a match end.',
    rulesH1:
      'Dominoes rules: Kozyol, Telephone and All Fives',
    playCta:
      'Play dominoes now',
  },
  a11y: {
    canvasLabel: 'Dominoes board. Use arrow keys to step through your hand, drop slots, and action buttons. Press Enter to select; press Escape to drop the current tile.',
  },
  narration: {
    subjects: {
      you: 'You',
      opponent: 'Opponent',
    },
    tile: {
      the: 'the',
      doublePrefix: 'double-',
      blank: 'blank',
    },
    arms: {
      one: 'first arm',
      two: 'second arm',
      three: 'third arm',
      four: 'fourth arm',
    },
    folds: {
      straight: 'straight',
      left: 'left',
      right: 'right',
    },
    cursor: {
      handTile: '{{tile}}, position {{index}} of {{count}}.',
      handTileForcedLead: '{{tile}}. Forced lead — press Enter to lead.',
      handTileMustLead: '{{tile}}, position {{index}} of {{count}}. You must lead with {{forced}}.',
      armSlot: 'Slot {{index}} of {{count}} — play {{tile}} on the {{arm}}, fold {{fold}}.',
      armSlotScores: 'Slot {{index}} of {{count}} — play {{tile}} on the {{arm}}, fold {{fold}}. Scores {{points}}.',
      actionDraw: 'Draw from the boneyard.',
      actionMuggins: 'Claim Muggins — {{points}} points, {{seconds}} seconds left.',
    },
    move: {
      selfLead: 'You led with {{tile}}.',
      selfPlay: 'You played {{tile}} on the {{arm}}.',
      otherLead: '{{subject}} led with {{tile}}.',
      otherPlay: '{{subject}} played {{tile}} on the {{arm}}.',
      openEnds: 'Open ends: {{ends}}.',
      scoredSelf: 'You scored {{points}}.',
      scoredOther: 'They scored {{points}}.',
      noScore: 'No score.',
      mugginsPromptSelf: 'Press Backspace to claim within {{seconds}} seconds.',
    },
    draw: {
      self: 'You drew a tile. You hold {{count}}.',
      other: '{{subject}} drew a tile. They hold {{count}}.',
    },
    pass: {
      self: 'You passed.',
      other: '{{subject}} passed.',
    },
    muggins: {
      claimSelf: 'You claimed {{points}} muggins points.',
      claimOther: '{{subject}} claimed {{points}} muggins points.',
      expired: 'Muggins forfeited.',
    },
    turn: {
      you: 'Your turn.',
      other: "{{subject}}'s turn.",
    },
    handOver: {
      wentOut: 'Hand {{hand}} is over. {{names}} went out.',
      blocked: 'Hand {{hand}} is over. Blocked.',
      awarded: '{{names}} scored {{points}}.',
      penaltyStem: 'Hand {{hand}} is over.',
    },
    matchOver: {
      win: 'Match over. {{names}} wins with {{score}}.',
      team: 'Match over. {{names}} win with {{score}}.',
      draw: 'Match over. Draw.',
      penaltyStem: 'Match over.',
    },
  },
  common: {
    back: '← Back',
    opponent: 'Opponent',
    seat: 'Seat',
    you: 'You',
    cycle: 'press Enter to cycle',
  },
  game: {
    pingOpponent: 'Ping opponent',
  },
  gameOverlay: {
    title: 'Game paused',
    openTooltip: 'Pause menu',
    settingsLabel: 'Settings',
    settingsBackLabel: '← Back',
    settingsViewTitle: 'Settings',
    restartLabel: 'Restart match',
    restartHintOnline: 'Online: all seats must agree. You get one proposal per match.',
    restartHintAlreadyProposed: "You've used your restart proposal this match.",
    restartHintPending: 'Waiting on the other seats…',
    returnToMenuLabel: 'Return to main menu',
    returnToMenuConfirmTitle: 'Leave this match and return to the menu?',
    returnToMenuConfirmYes: 'Yes, leave',
    returnToMenuConfirmNo: 'Stay',
    giveUpLabel: 'Give up',
    giveUpConfirmTitle: "Are you sure you're a coward?",
    giveUpConfirmYes: "Yes, I'm a coward",
    giveUpConfirmNo: "I'll fight on",
    settingsTabs: {
      gameplay: 'Gameplay',
      interface: 'Interface',
      audio: 'Audio',
    },
    discardConfirmTitle: 'Discard current game?',
    discardConfirmBody: 'Changing this setting will end the current game and start a new one.',
    discardConfirmYes: 'Discard and restart',
    discardConfirmNo: 'Cancel',
    close: 'Close',
  },
  auth: {
    signIn: 'Sign in',
    signOut: 'Sign out',
    google: 'Google',
    github: 'GitHub',
    completeProfile: 'Complete your profile →',
    profile: 'Profile',
    backToLanding: '← BN-games',
  },
  social: {
    close: 'Close',
    invite: {
      message: '{{sender}} invites you to {{game}}',
      moreCount_one: '+{{count}} more invite',
      moreCount_few: '+{{count}} more invites',
      moreCount_many: '+{{count}} more invites',
      moreCount_other: '+{{count}} more invites',
      accept: 'Accept',
      decline: 'Decline',
      acceptAria: "Accept {{sender}}'s {{game}} invite",
      declineAria: "Decline {{sender}}'s {{game}} invite",
    },
    dock: {
      pillLabel: 'From {{sender}}',
      pillAria: 'Invite from {{sender}} to {{game}} — show',
      popoverLabel: 'Invite',
      close: 'Close invite',
      leaveGameTitle: 'Leave this game?',
      leaveGameBody: 'Accepting opens {{game}} and leaves the current game. In an online game your seat is held for a while, so you can come back.',
      leaveGameConfirm: 'Leave and join',
      leaveGameCancel: 'Stay',
    },
    friendPicker: {
      button: 'Invite friend',
      modalTitle: 'Invite a friend',
      loading: 'Loading friends…',
      signInPrompt: 'Sign in to invite a friend.',
      empty: "You don't have any friends yet.",
      findFriends: 'Find friends',
      invite: 'Invite',
      inviteAria: 'Invite {{name}}',
      invited: 'Invited',
      invitedAria: 'Invited {{name}}',
      notAccepting: "This player isn't accepting invites right now",
      retryIn: 'Try again in {{seconds}}s',
    },
    addOpponent: {
      buttonMany: 'Add friends…',
      modalTitle: 'Add friends',
      add: 'Add {{name}} as friend',
      added: 'Added',
      addedAria: 'Added {{name}} as friend',
    },
  },
  mainMenu: {
    quickStart: 'Quick Start',
    newGame: 'New Game',
    rules: 'Rules',
    settings: 'Settings',
    history: 'Games History',
    about: 'About',
  },
  playMenu: {
    title: 'Play',
    playerCountLabel: 'Players',
    vsAi: 'vs Bot',
    vsHuman: 'vs Humans (hot-seat)',
    createOnline: 'Create online game',
    joinOnline: 'Join online game',
    gamesHistory: 'Games History',
    resume: 'Resume game',
    resumeOnline: 'Resume online ({{code}})',
    vsAiSession: 'vs Bot ({{difficulty}})',
    localMode: 'Hot-seat',
    onlineMode: 'vs {{opponent}}',
    justNow: 'just now',
    minutesAgo: '{{count}}m ago',
    hoursAgo: '{{count}}h ago',
    daysAgo: '{{count}}d ago',
    discardModal: {
      title: 'Discard active game?',
      body: 'Starting a new game will discard the current unfinished game. This cannot be undone.',
      keep: 'Keep game',
      discard: 'Discard',
    },
  },
  playerCount: {
    two: '2 players',
    three: '3 players',
    four: '4 players (FFA)',
    fourPartners: '4 players (2v2)',
    short: {
      two: '2',
      three: '3',
      four: '4',
      fourPartners: '2v2',
    },
  },
  seats: {
    south: 'South',
    west: 'West',
    north: 'North',
    east: 'East',
  },
  settings: {
    title: 'Settings',
    tabs: {
      gameplay: 'Gameplay',
      interface: 'Interface',
      audio: 'Audio',
    },
    rows: {
      playerName: 'Player name',
      sound: 'Sound',
      difficulty: 'Bot difficulty',
      theme: 'Theme',
      language: 'Language',
      variant: 'Variant',
      playerCount: 'Default players',
      pointGoal: 'Target score',
      mugginsStrict: 'Strict Muggins',
      mugginsAutoClaim: 'Auto-claim Muggins',
      hotSeatHide: 'Hide hand between turns',
      afkAssistEnabled: 'AFK move hint',
      afkRemindersEnabled: 'AFK reminder sound',
      turnStartSound: 'Your-turn sound',
      showAfkPingButton: 'Show ping button',
      verifiableDiceEnabled: 'Verifiable shuffle',
      showBoneyardCount: 'Show boneyard count',
      goatOpening13: '13-point opening',
      goatBaldFinish: '«Bald» finish on [0|0]',
    },
    difficulties: {
      easy: 'Easy',
      medium: 'Medium',
      hard: 'Hard',
    },
    themes: {
      mahogany: 'Mahogany',
      persian: 'Persian',
      deco: 'Deco',
      monte: 'Monte',
    },
    languages: {
      en: 'English',
      ru: 'Русский',
    },
    variants: {
      goat: 'Kozyol',
      'goat-2v2': 'Kozyol (2v2)',
      'all-fives': 'All Fives (Muggins)',
      'all-fives-2v2': 'All Fives (Muggins, 2v2)',
      telefon: 'Telephone (All Fives)',
      'telefon-2v2': 'Telephone (All Fives, 2v2)',
    },
    on: 'On',
    off: 'Off',
    namePrompt: 'Enter your name:',
  },
  about: {
    version: 'Version {{version}}',
    tech: 'TypeScript + Canvas',
  },
  rules: {
    screenTitle: 'Rules',
    goat: {
      title: 'Kozyol',
      items: {
        setup: {
          title: 'Setup',
          body: 'Double-six set (28 tiles). Every player draws 7 tiles whatever the table size; the rest form the boneyard (14 tiles with 2 players, 7 with 3, none with 4). Play 2v2 with your partner sitting across the table, or free-for-all with 2–4 players.',
        },
        lead: {
          title: 'Who leads',
          body: 'First hand: whoever holds [1|1] leads, and must lead with it. If [1|1] is in the boneyard, the lowest double in any hand leads; with no double dealt, the lowest tile. Every later hand is led by the winner of the previous one, with any tile they like.',
        },
        play: {
          title: 'Playing',
          body: 'Play a tile that matches one of the two open ends of the line. Doubles are laid crosswise but never branch — there is no spinner, the line always has exactly two ends. Nothing scores during play. If you cannot play, draw from the boneyard until you can; if it is empty, pass.',
        },
        ending: {
          title: 'End of a hand',
          body: 'A hand ends with «domino!» — someone plays their last tile — or with a «fish» (рыба): nobody can play and the boneyard is empty. In a fish, the side with the fewest pips left in hand wins.',
        },
        scoring: {
          title: 'Scoring',
          body: 'The winners write down nothing; every losing side writes down the pips left in hand — in 2v2, both partners\' pips combined. A hand left holding only [0|0] counts 25, only [6|6] counts 50, and [0|0] with [6|6] counts 75. «Eggs» (яйца): if a fish ends with a tie for the fewest pips, nothing is written and the points carry over to the loser of the next hand.',
        },
        match: {
          title: 'The goat',
          body: 'The match is played to 101. Whoever reaches 101 loses — they are the «kozyol», the goat. In free-for-all the lowest score wins. In Russian, sitting down to this game is called «забить козла» — "to hammer the goat".',
        },
        options: {
          title: 'Optional rules',
          body: 'Two house rules, both off by default in Settings. 13-point opening: while a side\'s score is 0, a hand\'s penalty is only written down if it is 13 or more. «Bald» finish: going out on [0|0] ends the match at once, and the finisher\'s side wins.',
        },
      },
    },
    'all-fives': {
      title: 'All Fives (Muggins)',
      items: {
        setup: {
          title: 'Setup',
          body: 'Double-six set (28 tiles). Each player draws a starting hand (7 for 2-player, 6 for 3-player, 5 for 4-player). The remaining tiles form the boneyard. The heaviest double in any hand leads the first hand; later hands rotate the lead clockwise.',
        },
        play: {
          title: 'Playing',
          body: 'On your turn, play a tile whose pip-half matches the open value at one of the chain arms. If you cannot play, draw from the boneyard until you can (or pass if it is empty). The first double to be covered becomes the spinner — two extra arms branch off its long sides, for up to four open ends in play. A double sitting at the end of an arm is still an open end, so it only takes the branch once play has moved past it; a double that leads needs both of its sides built on.',
        },
        scoring: {
          title: 'Scoring',
          body: 'After each play, sum the open values at every active arm. If the sum is a multiple of 5, you score that sum. Doubles count both halves at the lateral position; the spinner counts as 2 × face until other tiles cover its perpendicular arms.',
        },
        muggins: {
          title: 'Muggins',
          body: 'In strict mode, you must claim your score within a few seconds — tap Claim Muggins or lose the points. In lenient mode, scores are awarded automatically. Online play opens stealing: an opponent who spots a missed score within the window can claim it.',
        },
        ending: {
          title: 'Ending',
          body: 'A hand ends when one player empties their hand (player-out) or no player can play (blocked). The winner scores the loser-pip bonus — the sum of every opponent\'s remaining pips, rounded to the nearest 5. The match ends when a player (or team in 2v2) reaches the target score.',
        },
      },
    },
    telefon: {
      title: 'Telephone (All Fives)',
      items: {
        setup: {
          title: 'Setup',
          body: 'Double-six set (28 tiles). Every player draws 7 tiles regardless of seat count — with 4 players the boneyard starts empty (block-style). The seat holding [2|3] opens the first hand; if [2|3] is in the boneyard, the lead falls back to [1|1] → [2|2] → … → [6|6], then to the lowest-pip tile in any hand. The opening tile is forced — the leader MUST play that exact tile on turn 1.',
        },
        rotation: {
          title: 'Round rotation',
          body: 'After each hand the lead passes clockwise to the next seat — it does NOT stay with the winner. The player who opened a hand never opens the next one; the seat to their left does, no matter who won or who was blocked. Each round is started by a new player.',
        },
        scoring: {
          title: 'Scoring',
          body: 'Mid-hand plays score on multiples of 5 (same as All Fives — sum the open arm ends). The lead is special: it scores ONLY when it is [5|5] (open ends 5 + 5 = 10). Any other opening tile scores 0, even if its open ends already sum to a multiple of 5.',
        },
        ending: {
          title: 'Ending',
          body: 'Same as All Fives: a hand ends on player-out or block, with the loser-pip bonus rounded to the nearest 5. The match ends when a seat (or team in 2v2) reaches the target score.',
        },
      },
    },
  },
  banner: {
    yourTurn: 'Your turn',
    seatTurn: '{{seat}}\'s turn',
    claimMuggins: '{{seat}} — claim Muggins?',
    handOver: 'Hand Over',
    matchOver: 'Match Over',
    lastPlay: '{{actor}} played [{{a}},{{b}}].',
    lastPlayScored: '{{actor}} played [{{a}},{{b}}], scored {{points}}.',
    lastPlayWentOut: '{{actor}} played [{{a}},{{b}}] and went out.',
    lastPlayScoredWentOut: '{{actor}} played [{{a}},{{b}}], scored {{points}}, and went out.',
    lastDraw: '{{actor}} drew a tile.',
    lastPass: '{{actor}} passed.',
    lastClaim: '{{actor}} claimed +{{points}}.',
    lastClaimWithTile: '{{actor}} claimed +{{points}} with [{{a}},{{b}}].',
  },
  actionBar: {
    draw: 'Draw',
    claimMuggins: 'Claim Muggins',
  },
  playerInfo: {
    score: 'Score',
    tiles: 'Tiles',
    penalty: 'Penalty',
  },
  curtain: {
    title: '{{seat}}\'s turn',
    subtitle: 'Pass the device, then continue when ready.',
    ready: "I'm ready",
  },
  result: {
    handOver: 'Hand Over',
    matchOver: 'Match Over',
    blocked: '{{names}} won the blocked hand.',
    wentOut: '{{names}} went out.',
    matchWon: '{{names}} won the match.',
    drawn: 'Blocked hand.',
    nextHand: 'Next Hand',
    newMatch: 'New Match',
    menu: 'Menu',
    seatNumber: 'P{{number}}',
    teamNumber: 'T{{number}}',
    penalty: {
      domino: 'Domino! Hand won by {{names}}.',
      fish: 'Fish! Fewest pips: {{names}}.',
      eggs: 'Eggs! {{points}} points carry to the next hand.',
      written: '{{names}}: +{{points}} penalty.',
      bald: 'Bald goat! {{name}} went out on [0|0].',
      goat: '{{name}} is the goat!',
      goats: '{{names}} are the goats!',
    },
  },
  historyList: {
    title: 'Game history',
    empty: 'No saved games yet — play to start filling this list.',
    winnerTemplate: '{{names}} wins',
    draw: 'Draw',
    unfinished: 'Unfinished',
    movesCount: '{{count}} plays',
    deleteAria: 'Delete this game',
    deleteConfirm: 'Delete this saved game?',
    downloadAria: 'Download game logs',
    verifyAria: 'Verify match shuffles',
    modes: {
      ai: 'vs Bot',
      local: 'Hot-seat',
      online: 'Online',
    },
    accountSection: {
      title: 'Your account',
      loading: 'Loading…',
      empty: 'No online matches recorded yet.',
      statsLine: '{{wins}}W – {{losses}}L – {{draws}}D ({{played}} played)',
    },
    deviceSection: {
      title: 'On this device',
    },
  },
  verify: {
    title: 'Verify match — {{date}}',
    source: 'Source',
    chain: 'Chain',
    signedBy: 'Signed by',
    handLabel: 'Hand {{n}}',
    seedTemplate: 'shuffle seed {{seed}}',
    roundTemplate: 'round {{n}}',
    allOk: 'All {{count}} hands verified.',
    someFail: '{{ok}} of {{count}} hands verified — {{bad}} failed.',
    someUnverified: '{{ok}} of {{count}} hands verified — {{unverified}} unverified (drand outage).',
    verifying: 'Verifying signatures…',
    statusVerified: 'Verified',
    statusSeedMismatch: 'Shuffle tampered',
    statusSigInvalid: 'Signature invalid',
    statusUnverified: 'Unverified (no proof)',
    statusPending: 'Checking…',
    downloadProof: 'Download proof bundle',
    close: 'Close',
    explainer:
      'Each hand is BLS-verified against the pinned drand chain — anyone can re-check the bundle with the drand CLI.',
  },
  replay: {
    controls: {
      first: 'First',
      previous: 'Previous',
      play: 'Play',
      pause: 'Pause',
      next: 'Next',
      last: 'Last',
      speed: 'Speed',
      backToHistory: 'Back to history',
      backToMenu: 'Back to menu',
    },
  },
  online: {
    create: {
      title: 'Create room',
      codeLabel: 'Room code',
      share: 'Share this code with your opponents',
      variantLabel: 'Playing {{variant}}',
      seatCountLabel: 'Players',
      seatLabel: 'Your seat',
      create: 'Create room',
    },
    share: {
      copyCode: 'Copy code',
      copyLink: 'Copy link',
      copied: 'Copied!',
    },
    join: {
      title: 'Join room',
      codeLabel: 'Enter the room code',
      typeHint: 'Type the 4-character code',
      enterHint: 'Press Enter to join',
      submit: 'Join',
      variantLabel: 'Room is playing {{variant}}',
      paste: 'Paste',
    },
    verifiable: {
      hostBadge: 'Verifiable shuffle',
      hostHint: 'Both players must agree for the deal to use drand-signed randomness.',
      joinerOn: 'Host is using verifiable shuffle — deal results will be cryptographically auditable.',
      joinerOff: 'Host is not using verifiable shuffle.',
    },
    status: {
      connecting: 'Connecting',
      creating: 'Creating room',
      waitingForOpponent: 'Waiting for players',
      opponentJoined: 'Players joined',
      joining: 'Joining',
      couldNotJoin: 'Could not join',
      error: 'Connection error',
    },
    resumeModal: {
      reconnectingTitle: 'Reconnecting…',
      reconnectingBody: 'Reconnecting to your game…',
      seatTakenTitle: 'Seat taken',
      seatTakenBody: 'That seat belongs to another account. Sign in with that account, or start a new game.',
      roomGoneTitle: 'Table closed',
      roomGoneBody: 'This game is over — the table has closed.',
      roomFullTitle: 'Room full',
      roomFullBody: 'Every seat at this table is taken, and none of them is yours.',
      anonymousTitle: "We can't confirm this seat is yours",
      anonymousBody: 'This browser has no record of the game. Sign in before your next online game and your seat follows you to any device.',
      unreachableTitle: "Couldn't reach the server",
      unreachableBody: "The server didn't answer. Check your connection and try again.",
      signIn: 'Sign in',
      viewSaved: 'View saved position',
      retry: 'Try again',
      discard: 'Discard',
    },
    overlay: {
      opponentDisconnected: '{{name}} disconnected',
      waitingForReconnection: 'Waiting for reconnection {{countdown}}',
      reconnecting: 'Reconnecting',
      restoringGame: 'Restoring game {{countdown}}',
      connectionLost: 'Connection lost',
      gameEnded: 'The game has ended',
      rematchOffered: 'Rematch offered',
      waitingForOpponent: 'Waiting for {{name}}',
      rematchRequested: '{{name}} wants a rematch',
      rematchDeclined: '{{name}} declined the rematch',
      gameOverWin: 'You win!',
      gameOverLoss: 'You lose',
      gameOverDraw: 'Draw',
      gameOverPrompt: 'Play again?',
      buttons: {
        leave: 'Leave',
        rematch: 'Rematch',
        returnToMenu: 'Menu',
        cancel: 'Cancel',
        accept: 'Accept',
        decline: 'Decline',
      },
    },
  },
  pwa: {
    updateAvailable: {
      title: 'Update available',
      body: 'A new version of Dominoes is ready. Refresh to load it.',
      refresh: 'Refresh',
      later: 'Later',
    },
  },
};
